import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { getEntityNameLocoKeyByEntityType } from 'src/shared/utils/get-entity-name-loco-key-by-entity-type'
import { twMerge } from 'tailwind-merge'
import { useBreadcrumbs } from './hooks/use-breadcrumbs'

export const Breadcrumbs = () => {
  const { t } = useTranslation()
  const { filteredBreadcrumbs, handleHighlight, handleToggleSettings } =
    useBreadcrumbs()
  const containerRef = useRef<HTMLDivElement | null>(null)
  const breadcrumbsCount = filteredBreadcrumbs.length

  useEffect(() => {
    if (!containerRef.current || breadcrumbsCount === 0) {
      return
    }

    containerRef.current.scrollLeft = containerRef.current.scrollWidth
  }, [breadcrumbsCount])

  return (
    <div
      ref={containerRef}
      className={twMerge(
        'w-full items-center overflow-x-auto whitespace-nowrap border-divider01 border-l bg-bgPrimaryBase px-4.5 py-2.75 text-M',
        filteredBreadcrumbs.length ? 'flex' : 'hidden',
      )}
    >
      {filteredBreadcrumbs.map((b, i, arr) => (
        <React.Fragment key={b.id}>
          {arr.length > i + 1 ? (
            // biome-ignore lint/a11y/noStaticElementInteractions: wrapper handles hover and click interactions for grouped breadcrumb parts
            <span
              className="group"
              onClick={handleToggleSettings(b.id)}
              onMouseOver={handleHighlight(b.id)}
              onMouseOut={handleHighlight()}
            >
              <button
                type="button"
                className="relative cursor-pointer px-3.5 text-textTertiary group-hover:text-textSecondary"
              >
                {t(getEntityNameLocoKeyByEntityType(b.type))}
              </button>
              <i className="fa-solid fa-chevron-right cursor-pointer text-iconTertiary group-hover:text-iconSecondary" />
            </span>
          ) : (
            <button
              type="button"
              className="relative cursor-pointer pr-3 pl-3.5 text-textLink hover:text-textLinkHover"
              onMouseOver={handleHighlight(b.id)}
              onMouseOut={handleHighlight()}
            >
              {t(getEntityNameLocoKeyByEntityType(b.type))}
            </button>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}
